import React, { useState, useEffect } from 'react';
import { emailsAPI } from '../services/api';

const GOLD = 'var(--brand-primary, #d9a847)';

// statut → [libellé, couleur texte, fond]
const ST = {
  queued:     ['En file',   '#5F5E5A', '#F1EFE8'],
  sent:       ['Envoyé',    '#5F5E5A', '#F1EFE8'],
  delivered:  ['Délivré',   '#185FA5', '#E6F1FB'],
  opened:     ['Ouvert',    '#0F6E56', '#E1F5EE'],
  clicked:    ['Cliqué',    '#0F6E56', '#E1F5EE'],
  signed:     ['Signé',     '#3C3489', '#EEEDFE'],
  bounced:    ['Bounce',    '#A32D2D', '#FCEBEB'],
  complained: ['Plainte',   '#A32D2D', '#FCEBEB'],
  failed:     ['Échec',     '#A32D2D', '#FCEBEB'],
};
const TYPE_LABEL = { client: 'Envoi client', signature: 'Signature', relance: 'Relance' };

function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' }) + ' · ' +
         d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

export default function SuiviEmails() {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('Tous');
  const [openId, setOpenId] = useState(null);

  const load = () => {
    setLoading(true);
    emailsAPI.list({ limit: 200 })
      .then(res => setEmails(Array.isArray(res.data) ? res.data : []))
      .catch(() => setEmails([]))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const shown = emails.filter(m => {
    if (filter === 'Tous') return true;
    if (filter === 'Bounces') return m.status === 'bounced' || m.status === 'failed';
    if (filter === 'Envoi client') return m.type === 'client';
    if (filter === 'Signature') return m.type === 'signature';
    return true;
  });

  const kpis = [
    ['Envoyés', emails.length, ''],
    ['Délivrés', emails.filter(m => ['delivered', 'opened', 'clicked', 'signed'].includes(m.status)).length, '#185FA5'],
    ['Ouverts', emails.filter(m => ['opened', 'clicked'].includes(m.status)).length, '#0F6E56'],
    ['Bounces', emails.filter(m => ['bounced', 'failed', 'complained'].includes(m.status)).length, '#A32D2D'],
  ];

  const handleResend = async (id) => {
    try { await emailsAPI.resend(id); load(); } catch (e) { /* noop */ }
  };

  return (
    <div style={{ fontFamily: 'var(--font-body, sans-serif)', maxWidth: '1000px', margin: '0 auto', padding: '8px 4px' }}>
      <div style={{ fontFamily: 'var(--font-title, sans-serif)', fontWeight: 600, fontSize: '22px', marginBottom: '16px' }}>Suivi des emails</div>

      {/* KPIs */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '16px' }}>
        {kpis.map((k, i) => (
          <div key={i} style={{ background: '#fff', border: '0.5px solid rgba(0,0,0,0.07)', borderRadius: '10px', padding: '13px 15px' }}>
            <div style={{ fontSize: '12px', color: '#8b8576' }}>{k[0]}</div>
            <div style={{ fontSize: '26px', fontWeight: 500, marginTop: '2px', color: k[2] || '#1d1d1f' }}>{k[1]}</div>
          </div>
        ))}
      </div>

      {/* Filtres */}
      <div style={{ display: 'flex', gap: '7px', marginBottom: '14px' }}>
        {['Tous', 'Envoi client', 'Signature', 'Bounces'].map(f => (
          <span key={f} onClick={() => setFilter(f)} style={{
            cursor: 'pointer', padding: '6px 13px', fontSize: '12.5px', borderRadius: '8px',
            border: '0.5px solid ' + (filter === f ? '#1f1612' : 'rgba(0,0,0,0.1)'),
            background: filter === f ? '#1f1612' : '#fff', color: filter === f ? GOLD : '#8b8576',
          }}>{f}</span>
        ))}
      </div>

      {/* Liste */}
      <div style={{ background: '#fff', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '12px', overflow: 'hidden' }}>
        {loading ? (
          <div style={{ padding: '24px', textAlign: 'center', color: '#8b8576', fontSize: '13px' }}>Chargement…</div>
        ) : shown.length === 0 ? (
          <div style={{ padding: '24px', textAlign: 'center', color: '#aaa49a', fontSize: '13px' }}>Aucun envoi.</div>
        ) : shown.map(m => {
          const s = ST[m.status] || ST.sent;
          const exp = openId === m.id;
          return (
            <div key={m.id}>
              <div onClick={() => setOpenId(exp ? null : m.id)} style={{
                display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px',
                borderTop: '0.5px solid rgba(0,0,0,0.05)', cursor: 'pointer',
              }}>
                <span style={{ fontSize: '14px', color: '#bbb' }}>{exp ? '▾' : '▸'}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '13px', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.to_email}</div>
                  <div style={{ fontSize: '11px', color: '#8b8576' }}>{(m.societe_nom || m.reference || '—')} · {fmtDate(m.created_at)}</div>
                </div>
                <span style={{ fontSize: '10.5px', color: '#8a7234', background: 'rgba(217,168,71,0.14)', padding: '2px 9px', borderRadius: '20px', whiteSpace: 'nowrap' }}>{TYPE_LABEL[m.type] || m.type}</span>
                <span style={{ fontSize: '11px', color: '#8b8576', width: '50px', textAlign: 'center' }}>📎 {(m.document_ids || []).length}</span>
                <span style={{ fontSize: '10.5px', color: s[1], background: s[2], padding: '2px 9px', borderRadius: '20px', width: '64px', textAlign: 'center' }}>{s[0]}</span>
              </div>

              {exp && (
                <div style={{ padding: '14px 16px 16px 42px', background: '#fbf9f4', borderTop: '0.5px solid rgba(0,0,0,0.04)' }}>
                  <div style={{ fontSize: '10px', letterSpacing: '.04em', color: '#8b8576', marginBottom: '10px' }}>DÉTAIL DU MAIL</div>
                  {m.subject && (
                    <div style={{ fontSize: '12px', color: '#1d1d1f', marginBottom: '5px' }}><span style={{ color: '#8b8576' }}>Sujet · </span>{m.subject}</div>
                  )}
                  <div style={{ fontSize: '12px', color: '#1d1d1f', marginBottom: '5px' }}><span style={{ color: '#8b8576' }}>À · </span>{m.to_email}</div>
                  {(m.bcc && m.bcc.length > 0) && (
                    <div style={{ fontSize: '12px', color: '#1d1d1f', marginBottom: '5px' }}><span style={{ color: '#8b8576' }}>Copie cachée · </span>{m.bcc.join(', ')}</div>
                  )}
                  {(m.documents && m.documents.length > 0) && (
                    <div style={{ fontSize: '12px', color: '#1d1d1f', marginBottom: '5px' }}>
                      <span style={{ color: '#8b8576' }}>Pièces jointes · </span>
                      {m.documents.map(d => d.nom).filter(Boolean).join(', ') || `${m.documents.length} pièce(s)`}
                    </div>
                  )}
                  {m.message && (
                    <div style={{ marginTop: '8px', padding: '10px 12px', background: '#fff', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '8px', fontSize: '12.5px', color: '#424245', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{m.message}</div>
                  )}
                  <div style={{ fontSize: '10px', letterSpacing: '.04em', color: '#8b8576', margin: '18px 0 10px' }}>FIL D'ÉVÉNEMENTS · PREUVE D'ENVOI</div>
                  <div style={{ borderLeft: '2px solid rgba(217,168,71,0.3)', paddingLeft: '14px' }}>
                    {(m.events || []).map((e, i) => (
                      <div key={i} style={{ position: 'relative', paddingBottom: '9px' }}>
                        <span style={{ position: 'absolute', left: '-19px', top: '3px', width: '7px', height: '7px', borderRadius: '50%', background: (e.status === 'bounced' || e.status === 'failed') ? '#A32D2D' : GOLD }} />
                        <div style={{ fontSize: '12px', color: '#1d1d1f' }}>{(ST[e.status] || [e.status])[0]}</div>
                        <div style={{ fontSize: '10.5px', color: '#aaa49a' }}>{fmtDate(e.at)}</div>
                      </div>
                    ))}
                  </div>
                  {m.type !== 'signature' && (
                    <div style={{ marginTop: '10px' }}>
                      <span onClick={() => handleResend(m.id)} style={{ fontSize: '12px', color: '#8a7234', cursor: 'pointer' }}>↻ Renvoyer</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
